import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import ShareIcon from '@wix/da-ds/pkg/Icons/24x24/Share';
import { BiData } from '@wix/da-bi/pkg/events';
import { getDeviationResourceType } from '../../../../_helpers';
import { useCopyDeviationLinkClick } from '../../../../../utils/hooks/useCopyLinkClick';
import overlayStyles from '../../../../Helper/OverlayIcons.scss';
const ShareControl = ({ deviation, className, buttonClassName, iconClassName, textClassName })=>{
    const { t } = useTranslation();
    const { onCopyLinkClick } = useCopyDeviationLinkClick(deviation);
    return /*#__PURE__*/ React.createElement("div", {
        className: className
    }, /*#__PURE__*/ React.createElement(TextButton, {
        size: "medium",
        variant: "main",
        className: classnames(buttonClassName, overlayStyles['icon-button']),
        onClick: onCopyLinkClick,
        biData: BiData({
            evid: 355,
            typeid: getDeviationResourceType(deviation),
            itemid: deviation.deviationId,
            deviationid: deviation.deviationId
        }),
        "aria-label": t('deviationview.overlay.a11y.share')
    }, /*#__PURE__*/ React.createElement(ShareIcon, {
        size: IconSize.MEDIUM,
        withPadding: false,
        disableDefaultColors: true,
        className: classnames(overlayStyles['icon'], iconClassName)
    }), /*#__PURE__*/ React.createElement("span", {
        className: textClassName
    }, t('share.copyLink'))));
};
ShareControl.displayName = 'ShareControl';
export default ShareControl;

//# sourceMappingURL=ShareControl.js.map